import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from '../../../../../Common/Modal';
import FormCFEComponent from '../common/FormCFEComponent';
import FormCompletion from '../common/FormCompletion';
import { transformWidgetProps } from '@/components/WidgetMaker/utils/common';

const ModernFormMobile = (props) => {
  const { open, handleClose } = props;
  const storeData = useSelector((state) => state.storeReducer.store);
  const themeFormConfig = storeData?.theme?.components?.Body?.filter(
    (comp) => comp.sub_type === 'Form'
  );
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [formConfig, setFormConfig] = useState(null);
  const [transformedState, setTransfomedState] = useState({});

  useEffect(() => {
    if (themeFormConfig && themeFormConfig?.length > 0) {
      setFormConfig(themeFormConfig[0]);
    }
  }, [themeFormConfig]);

  useEffect(() => {
    setTransfomedState(transformWidgetProps(formConfig?.config?.children));
  }, [formConfig]);

  return (
    <>
      <Modal
        visible={open}
        className="bottom-modal"
        animation={'slideUp'}
        onClose={handleClose}
        // style={{ padding: 0 }}
        customStyles={{
          padding: '0px',
          maxHeight: '100%',
        }}
      >
        {isFormSubmit ? (
          <FormCompletion onClose={handleClose} />
        ) : (
          <FormCFEComponent
            heading={transformedState?.heading?.text || ''}
            description={transformedState?.description?.text || ''}
            buttonText={
              transformedState.button ? transformedState.button.content[0].btnText : ''
            }
            buttonConfig={transformedState.button ? transformedState.button : null}
            storeData={storeData}
            widgetId={formConfig?.widget_id}
            toggleFormCompletion={setIsFormSubmit}
            onClose={handleClose}
            open={open}
          />
        )}
      </Modal>
    </>
  );
};

export default ModernFormMobile;
